import type { RouteRecordRaw } from 'vue-router'
import { OldTasksSettingsRouteNames } from '@/routes/user/tasks/types'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'
import { UserSettingsRoutes } from '@/routes/user/settings'

export const getOldTasksSettingsRoute = (): RouteRecordRaw => ({
  name: OldTasksSettingsRouteNames.settingsIndex,
  path: 'tasks/settings',
  redirect: { name: OldTasksSettingsRouteNames.settings },
  children: [
    getOldRouteWithRedirect(OldTasksSettingsRouteNames.settings, 'overview', UserSettingsRoutes.TasksOverview),
    {
      name: OldTasksSettingsRouteNames.settingsBoard,
      path: ':boardId',
      props: true,
      redirect: { name: OldTasksSettingsRouteNames.settingsBoardDetails },
      children: [
        getOldRouteWithRedirect(OldTasksSettingsRouteNames.settingsBoardDetails, '', UserSettingsRoutes.TasksBoard),
        getOldRouteWithRedirect(
          OldTasksSettingsRouteNames.settingsBoardArchivedDetails,
          'archived',
          UserSettingsRoutes.TasksBoardArchived,
        ),
        getOldRouteWithRedirect(
          OldTasksSettingsRouteNames.settingsStages,
          'stages',
          UserSettingsRoutes.TasksBoardStage,
        ),
      ],
    },
  ],
})
